import React from 'react';

import { useUserJobProspectsState, useUserJobProspectsActions } from './UserJobProspectsContext';

import UserJobProspectsLoader from './UserJobProspectsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import UserJobProspectsTable from './UserJobProspectsTable';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import DeleteJobProspectForm from './DeleteJobProspectForm';
import ClosedJobModal from './ClosedJobModal';
import styles from './UserJobProspects.module.scss';

const UserJobProspectsContent = () => {
  const state = useUserJobProspectsState();
  const { closeDeleteJobProspectModal } = useUserJobProspectsActions();

  if (state?.loading) {
    return (
      <div className={styles.pageLayout}>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading</p>
      </div>
    );
  }

  const userName = state?.userName;
  const userEmail = state?.userEmail;

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        <PageTitle text={`Job Prospects for ${userName || 'User'}`} />
        {userEmail && (
          <p style={{ marginTop: '-0.5rem', color: 'var(--color-text-muted)' }}>{userEmail}</p>
        )}
        <UserJobProspectsTable />
      </Stack>
      <StandardModal
        isOpen={state?.deleteJobProspectModalIsOpen}
        contentLabel={'Delete This Job Prospect'}
        onRequestClose={() => {
          closeDeleteJobProspectModal();
        }}
      >
        <DeleteJobProspectForm />
      </StandardModal>
      <ClosedJobModal />
    </div>
  );
};

const UserJobProspects = ({ userId }) => {
  const { initializeState } = useUserJobProspectsActions();

  React.useEffect(() => {
    initializeState(userId);
  }, [userId]);

  return (
    <>
      <UserJobProspectsLoader />
      <UserJobProspectsContent />
    </>
  );
};

export default UserJobProspects;
